class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.querySelector('.announcement-closer').addEventListener('click', () => {
      this.closeBar();
    });
  }

  connectedCallback() {
    this.getItemWithExpiry('isNotificationBarClosed', (storedValue) => {
      if (storedValue == 'true') {
        this.closeBar();
      }
    });
  }

  setItemWithExpiry(key, value, days) {
    const now = new Date();
    const expiry = now.getTime() + days * 24 * 60 * 60 * 1000;
    const item = {
      value,
      expiry,
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  getItemWithExpiry(key, callback) {
    const itemStr = localStorage.getItem(key);

    if (!itemStr) return null;

    const item = JSON.parse(itemStr);
    const now = new Date();

    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }

    if (callback) callback(item.value);

    return item.value;
  }

  closeBar() {
    this.setItemWithExpiry('isNotificationBarClosed', 'true', 10);
    this.classList.add('visually-hidden');
    if (
      document.querySelector(
        '.announcement-bar-section~.shopify-section-group-header-group .header',
      )
    ) {
      document.querySelector(
        '.announcement-bar-section~.shopify-section-group-header-group .header',
      ).style.top = 0;
    }
  }
}

customElements.define('announcement-bar', AnnouncementBar);
